<template>
    <h1 class="steps-header">
        <span v-if="pageAttributes.aa_steps_header">
            {{ getHeader }}
        </span>

    </h1>
</template>

<script>
    import { mapState, mapGetters } from 'vuex';
    import { sprintf } from 'sprintf-js';

    export default {
        name: 'steps-header',
        computed: {
            getHeader() {
                return this.pageAttributes.aa_steps_header
            },
            shouldDisplaySteps() {
                return this.displaySteps;
            },
            stepsClasses() {
                return 'steps-count qt-stepcount' + (this.stepNumber || '');
            },

            getStepString() {
                if (!this.stepNumber || !this.totalStepsCount) {
                    return '';
                }

                try {
                    return sprintf(
                        this.pageAttributes.aa_steps_counter,
                        this.stepNumber,
                        this.totalStepsCount
                    );
                } catch (e) {
                    return '';
                }
            },

            stepNumber() {
                if (this.getCurrentStep && this.getCurrentStep.countStep) {
                    // get index of current counted step
                    for (const [i, step] of this.countedSteps.entries()) {
                        if (step.stepIndex === this.getCurrentStep.stepIndex) {
                            // removed sign up from steps count and step is after sign up
                            if (
                                this.excludeSignUpFromStepsCount &&
                                step.stepIndex > this.signUpStep.stepIndex
                            ) {
                                return i;
                            }

                            return i + 1;
                        }
                    }
                }

                return false;
            },

            totalStepsCount() {
                if (this.excludeSignUpFromStepsCount) {
                    return this.countedSteps.length - 1;
                }

                return this.countedSteps.length;
            },

            excludeSignUpFromStepsCount() {
                return (
                    this.signUpStep && this.$store.state.flow.didCompleteSignIn
                );
            },

            signUpStep() {
                return this.countedSteps.find((step) => {
                    return step.name === 'SIGNUP';
                });
            },

            ...mapGetters('flow', [
                'displaySteps',
                'countedSteps',
                'getCurrentStep'
            ]),
            ...mapState('pageAttributes', {
                pageAttributes: (state) => state.attributes
            }),
        }
    };
</script>
